import { isRealProd, isHK, isMY } from 'src/config/env';

let sensors = null;
const limit = 20; // 每个 track 限制轮询次数

/**
 * 神策埋点初始化
 */
export function sInit() {
	function onload() {
		import(/* webpackChunkName: "sensors" */ 'sa-sdk-javascript').then((Module) => {
			if (!Module?.default) return;
			sensors = Module.default;
			let server_url = '';
			if (isHK) {
				// 华盛通域名
				server_url = `//sensors-api.hstong.com/sa?project=${isRealProd ? 'vbokers' : 'hst_test'}`;
			} else if (isMY) {
				// 马来西亚展业域名
				server_url = `//sensors-api.mbkr.com.my/sa?project=${isRealProd ? 'production' : 'default'}`;
			} else {
				server_url = `//sensors-api.hstong.com/sa?project=${isRealProd ? 'vbokers' : 'hst_test'}`;
			}
			sensors.init({
				server_url,
				app_js_bridge: true, // app打通H5
				is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
				use_client_time: true, // 是否使用客户端系统时间
				send_type: 'beacon',
				heatmap: {
					// 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
					clickmap: 'default',
					// 是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
					scroll_notice_map: 'not_collect',
				},
				show_log: true,
			});
			// 注册公共属性，注册所有事件都需要添加的属性
			sensors.registerPage({
				platform_type: 'H5',
			});
			// 用于采集 $pageview 事件。
			sensors.quick('autoTrack');
		});
	}

	onload();
}

// 轮询神策
export function polling(cb, opts) {
	if (opts?.timeout) clearTimeout(opts.timeout);
	if (opts?.num && opts.num > limit) return;
	if (!sensors) {
		let timeout = setTimeout(() => {
			let num = opts?.num ? opts.num + 1 : 1;
			polling(cb, { ...opts, timeout, num });
			num = null;
			timeout = null;
		}, 300);
	} else {
		cb();
	}
}

/**
 * 事件上报
 */
export function sTrack(key, value) {
	polling(() => {
		sensors.track(key, value);
	});
}
